<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M49 5H15a2 2 0 00-2 2v50a2 2 0 002 2h34a2 2 0 002-2V7a2 2 0 00-2-2zm-1 3v33.5h-.88l-7.45-14.95a1 1 0 00-1.79 0l-4.09 8.21-8.08-16.21a1 1 0 00-.87-.55 1.06 1.06 0 00-.9.52L16 32.86V8zM16 36.91a1.49 1.49 0 00.12-.14l8.65-15.62 8.13 16.3a1 1 0 001.79 0l4.09-8.21 6.11 12.26H16zM16 56V44.5h32V56z"/><path d="M40 21.5a5.5 5.5 0 10-5.5-5.5 5.51 5.51 0 005.5 5.5zm0-9a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z"/></svg>